export default "__VITE_ASSET__BKuL8Bmx__"